import controller from './double-opt-timeout-dialog.controller';

export default {
  controller,
  template: require('./double-opt-timeout-dialog.html')
};



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/timeout/double-opt-timeout-dialog.component.ts